import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom';

import classes from './PokemonDetail.module.scss';

//GraphQL
import { useQuery } from '@apollo/client';
import { GET_POKEMON_DETAILS } from '../../components/graphql/get-pokemons';


import { css } from '@emotion/css';

// Components
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import LoadingError from '../../components/LoadingError/LoadingError';
import Modal from '../../components/Modal/Modal';
import { ButtonPrimary, ButtonDanger } from '../../components/Button/Button';
import PokemonType from '../../components/PokemonType/PokemonType';
import EcommerceAds from '../../components/EcommerceAds/EcommerceAds';

import pokemongrassbg from '../../image/pokemongrassbg.png';
function PokemonDetail(props) {
    let { paramsPokemonID } = useParams();



    //Current Pokemon details...
    const [pokemonDetail, setPokemonDetail] = useState({
        sprites: {
            front_default: ''
        },
        moves: [],
        types: [],
        name: '...',
        id: 0,
        stats: []
    });

    const [uiState, setUiState] = useState({
        show: false
    });


    const showPokemonHuntModal = () => {
        setUiState({ show: true });
    };

    const hidePokemonHuntModal = () => {
        setUiState({ show: false });
    };


    // componentDidMount
    // useEffect(() => {
    // GraphQL replaced axios

    //     get the current ID pokemon detail..

    //     axios.get(`/pokemon/${paramsPokemonID}`)
    //         .then((response) => {
    //             setPokemonDetail(response.data);
    //             // console.log(response.data.id);
    //             // console.log(response.data.moves);
    //         });

    // }, []);


    const { loading, error, data } = useQuery(GET_POKEMON_DETAILS, {
        variables: { name: paramsPokemonID },
        onCompleted: () => {
            setPokemonDetail(
                {

                    sprites: data.pokemon.sprites,
                    moves: data.pokemon.moves,
                    types: data.pokemon.types,
                    id: data.pokemon.id,
                    name: data.pokemon.name,
                    stats: data.pokemon.stats,
                }
            );
        }
    });

    //temporary store pokemon caught data
    const [pokemonCaught, setPokemonCaught] = useState({
        id: 0,
        name: '',
        nickname: '',
        image: ''
    });


    useEffect(() => {
        const img = document.createElement('img');
        img.src = pokemongrassbg;
    }, []);

    const { setMySavedData, showNotification, currentTime} = props;

    // execute autosave if pokemon caught
    useEffect(() => { //pokemonCaught, what to do?
        // console.log('Pokemon Caught Data');
        // console.log(pokemonCaught);

        if (pokemonCaught.id !== 0) {
            //new Pokemon is caught! auto set to Save state...
            setMySavedData((previousSavedData) => {
                return {
                    pokemonList: [
                        ...previousSavedData.pokemonList,
                        {
                            name: pokemonCaught.name,
                            nickname: pokemonCaught.nickname,
                            id: pokemonCaught.id,
                            image: pokemonCaught.image,
                            ownedPokemonUUID: previousSavedData.highestOwnedPokemonUUID + 1
                        }
                    ],
                    lastUpdated: currentTime,
                    highestOwnedPokemonUUID: previousSavedData.highestOwnedPokemonUUID + 1
                }
            });

            if (window.Notification && Notification.permission === 'granted') {
                if (navigator.userAgent.match(/Android|iPhone|iPod|Blackberry/i)) {
                } else {
                    showNotification(`NICE! ${pokemonCaught.nickname} is now stored to MY POKEMON!`);
                }
            }
            alert(`NICE! ${pokemonCaught.nickname} is now stored to MY POKEMON!`);
            hidePokemonHuntModal();

            //saved to state, now clear the state...
            setPokemonCaught({
                id: 0,
                name: '',
                nickname: ''
            });
            // console.log('Pokemon Caught Data CLEARED');

        }

    }, [pokemonCaught, setMySavedData, showNotification, currentTime]);


    // useEffect(() => {
    //     console.log('pokemonDetail updated');
    // }, [pokemonDetail]);



    const saveCaughtPokemonData = (pokemonName) => {
        setPokemonCaught(
            () => {
                return {
                    id: pokemonDetail.id,
                    name: pokemonDetail.name,
                    nickname: pokemonName,
                    image: pokemonDetail.sprites.front_default
                }
            }
        )
    };

    function catchPokemon() {

        let pokemonNicknameForm = '';
        let cancelConfirm = false;

        let uniqueNameArrays = props.mySavedData.pokemonList.map((item) => (item.nickname));

        // console.log('pokemon nicknames');
        // console.log(uniqueNameArrays);

        //chance plays...
        if (Math.random() >= 0.5) { //0..4.99 and 5.00..0.999 theoritically fair!
            pokemonFound();
        } else {
            alert('Pokemon ran away...');
        }

        function pokemonFound() {
            let existMessage = '';

            do { //keep prompting until canceled or new nickname found...

                pokemonNicknameForm = window.prompt(`${existMessage} You caught ${pokemonDetail.name} Please enter your new pokemon Nickname!`);

                if (uniqueNameArrays.indexOf(pokemonNicknameForm) >= 0) {
                    // unique name clash, please rename!
                    existMessage = `${pokemonNicknameForm} already exist! please input other name! \n`;
                    pokemonNicknameForm = null;
                } else if (pokemonNicknameForm != null && pokemonNicknameForm !== '') { //
                    //user accepted the pokemon... saving state of the pokemon caught...
                    saveCaughtPokemonData(pokemonNicknameForm);

                } else if (pokemonNicknameForm === '') { //means no name
                    alert('Cannot be blank');
                } else if (pokemonNicknameForm === null) { //means no name
                    cancelConfirm = window.confirm(`Are you sure want to release this ${pokemonDetail.name} ??`);

                    if (cancelConfirm) {
                        alert('Pokemon released....');
                        hidePokemonHuntModal();
                        break;//break the loop... ok you may stop asking me the nickname..
                    }
                }

            } while (pokemonNicknameForm === null || pokemonNicknameForm === '');
            existMessage = ''; // reset exist message

        }
    }


    return (
        <div>

            { loading ? <LoadingSpinner />
                : error ?
                    <LoadingError />
                    :
                    <div className={css`padding-left:15px; padding-right:15px;`}>
                        <div className={classes.detailLayout}>
                            <div className={classes.detailLayoutLeft}>
                                <h1>{paramsPokemonID}</h1>
                                <div className={classes.pokemonDetailImageContainer}>
                                    <img className={classes.pokemonDetailImage} src={pokemonDetail.sprites.front_default} alt=""></img>
                                </div>
                            </div>
                            <div className={classes.detailLayoutRight}>
                                <ButtonDanger onClick={showPokemonHuntModal}>
                                    {`Go Find and Catch ${pokemonDetail.name}`}
                                </ButtonDanger>
                                <Modal show={uiState.show} handleClose={hidePokemonHuntModal} modalType="modalCatchingPokemon">
                                    <div className={css`
                                        height:100%;
                                        width:100%;
                                        display: flex;
                                        flex-direction: column;
                                        align-items: center;
                                        justify-content: center;
                                    `}>
                                        <div className={css`color:white;`}>
                                            {`Found ${pokemonDetail.name} in the wild! `}
                                        </div>
                                        <img className={css`
                                            width: 250px;
                                        `} src={pokemonDetail.sprites.front_default} alt=""></img>
                                        <ButtonPrimary onClick={catchPokemon}>
                                            Catch this Pokemon!!!
                                        </ButtonPrimary >
                                    </div>
                                </Modal>
                                <div className={classes.movesAndTypes}>

                                    <div className={classes.typesContainer}>
                                        <h2>Types:</h2>
                                        <div className={classes.typesList}>
                                            {
                                                pokemonDetail.types.map(
                                                    (item) => (
                                                        <PokemonType key={item.type.name} type={item.type.name}>{item.type.name}</PokemonType>
                                                    )
                                                )
                                            }
                                        </div>

                                        <div>
                                            <h2>General Stats:</h2>

                                            {
                                                pokemonDetail.stats.map((item, index) => (
                                                    <div key={index} className={css`margin-bottom:8px;`}>
                                                        {item.stat.name}: <b> {item.base_stat}</b>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>

                                    <div className={classes.movesContainer}>
                                        <h2>Moves:</h2>
                                        <div className={classes.movesList}>
                                            {
                                                pokemonDetail.moves.map(
                                                    (item) => (
                                                        <div className={classes.movesItem} key={item.move.name}>{item.move.name}</div>
                                                    )
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>

                        <div>
                            <div>
                                <h2>See other
                                    {
                                        pokemonDetail.types.map(
                                            (item, index) => {
                                                return (
                                                    <span key={item.type.name}>
                                                        {index > 0 ? <span> &nbsp;or</span> : ''}
                                                        <PokemonType type={item.type.name}>{item.type.name}</PokemonType>
                                                    </span>
                                                )
                                            }
                                        )
                                    }
                                    &nbsp;pokemon...</h2>

                                (Related pokemon Coming soon in V2...)
                            </div>





                        </div>

                        <EcommerceAds name={paramsPokemonID} />
                    </div>

            }
        </div>

    )
}

PokemonDetail.propTypes = {

}

export default PokemonDetail

